<template>
<div class="s-home">
  <!-- <SystemLogin class="s-header"></SystemLogin> -->
  <WHeader class="s-header"></WHeader>
  <!-- <GaodeMap ref="map" class="s-map" @complate="getMapData"></GaodeMap> -->
  <WGaodeMap ref="map" class="s-map" @complate="getMapData" :projectStatus="projectStatus"></WGaodeMap>
  <!-- <TopBlock class="s-top-block"></TopBlock> -->
  <WTopBlock class="s-top-block"></WTopBlock>
  <!-- 左侧-->
  <!-- <span class="s-left" :class="{ 'left-show': panelShow === true, 'left-hide': panelShow === false }">
    <ListBlock :ids="[1, 2, 3]"></ListBlock>
  </span> -->
  <span class="s-left">
    <WListBlock :wIds="[1, 2]" :projectStatus="projectStatus"></WListBlock>
  </span>
  <!-- 右侧-->
  <!-- <span class="s-right" :class="{ 'right-show': panelShow === true, 'right-hide': panelShow === false }">
    <ListBlock :ids="[4, 5, 6]"></ListBlock>
  </span> -->
  <span class="s-right">
    <WListBlock :wIds="[3, 4]" :projectStatus="projectStatus"></WListBlock>
  </span>
  <!-- 工具条-->
  <span>
    <TextBlock class="s-list-panel">
      <ul>
        <li class="panelLi" v-for="(item, index) in panelList" :key="index" @click="panelClick(item)">
          <img :src="item.img" alt="">
          <span>{{item.name}}</span>
        </li>
        <!-- <li>
          <img src="/static/images/svolt/normal.png" />
          <span>运行</span>
        </li>
        <li>
          <img src="/static/images/svolt/debug.png" />
          <span>调试</span>
        </li>
        <li>
          <img src="/static/images/svolt/build.png" />
          <span>在建</span>
        </li>
        <li>
          <img src="/static/images/svolt/offLine.png" />
          <span>离线</span>
        </li> -->
      </ul>
    </TextBlock>
    <i v-if="searchInput!=''" class="el-icon-circle-close" @click="clearInput()"></i>
    <TextBlock class="s-search">
      <el-autocomplete style="width: 100%;color:#FFFFFF;" class="inline-input" popper-class="select-down" v-model="searchInput" :fetch-suggestions="querySearch" placeholder="请输入要查找的项目" :trigger-on-focus="isfocus" @select="handleSelect" @keyup.enter.native="handleSelect">
        <i slot="suffix" @click="handleSelect" class="el-input__icon el-icon-search" style="color: #fff;"><span style="margin-left: 4px;color: #fff;">搜索</span></i>
      </el-autocomplete>
    </TextBlock>
    <!-- <TextBlock class="s-hide-panel">
      <span @click="switchPanel">{{ panelTitle }}</span>
    </TextBlock> -->
  </span>
  <!-- 预警告警 -->
  <EarlyWarningAlarm v-if="isAlarmBlock" class="alarmBlock" :alarmMsg="alarmMsg"></EarlyWarningAlarm>
</div>
</template>

<script>
import SystemLogin from '@/views/login/components/header';
import WHeader from '@/views/login/components/w-header';
// import GaodeMap from '../components/gaode-map';
import WGaodeMap from '../components/w-gaode-map';
import TextBlock from '../components/text-block';
// import TopBlock from './components/top-block.vue';
import WTopBlock from './components/w-top-block.vue';
// import ListBlock from './components/list-block';
import WListBlock from './components/w-list-block';
import EarlyWarningAlarm from './components/early-warning-alarm';
import JQ from 'jquery';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import {
  getToken
} from '@/utils/auth';
export default {
  name: 'MixChart',
  components: {
    SystemLogin,
    WHeader,
    // GaodeMap,
    WGaodeMap,
    TextBlock,
    // TopBlock,
    WTopBlock,
    // ListBlock,
    WListBlock,
    EarlyWarningAlarm
  },
  data() {
    return {
      searchInput: '',
      panelTitle: '隐藏面板',
      panelShow: false,
      solarVolume: {
        title: '光伏总容量（MW）',
        number: '300'
      },
      totalEnergy: {
        title: '累计发电量(kWh)',
        number: '5623'
      },
      todayEnergy: {
        title: '今日发电量(kWh)',
        number: '320'
      },
      restaurants: [],
      currentItem: '', //当前值
      isfocus: true,
      isAlarmBlock: false,
      Authorization: '',
      stompClient: '',
      projectList: [],
      oSoc: {},
      panelList: [{
        id: '',
        img: '',
        name: '全部'
      }, {
        id: 274,
        img: '/static/images/svolt/normal.png',
        name: '投运'
      }, {
        id: 300,
        img: '/static/images/svolt/debug.png',
        name: '调试'
      }, {
        id: 276,
        img: '/static/images/svolt/build.png',
        name: '在建'
      }, {
        id: 275,
        img: '/static/images/svolt/offLine.png',
        name: '离线'
      }],
      projectStatus: '',
      alarmMsg: ''
    };
  },
  created() {},
  mounted() {
    JQ(document).on('click', function (event) {
      var container = JQ('.s-search');
      var selectDown = JQ('.select-down');
      if (container.has(event.target).length === 0) {
        selectDown.hide();
      } else {
        selectDown.show();
      }
    })
    this.initWebSocket();
  },
  // destroyed() {
  //   this.oSoc.disConnect();
  // },
  methods: {
    clearInput() {
      this.searchInput = "";
    },
    //切换面板
    switchPanel() {
      this.panelTitle = this.panelTitle == '隐藏面板' ? '显示面板' : '隐藏面板';
      this.panelShow = this.panelShow == false ? true : false;
    },
    //获取底图数据
    getMapData(data) {
      this.restaurants = data;
      this.restaurants.map(item => {
        item.bakvalue = item.value;
        item.value = item.projectName;
      });
    },
    //搜索
    handleSelect(item) {
      // console.log(item);
      if (item && item.location) {
        this.currentItem = item;
        // let [a, b] = item.location.split(',');
        // this.$refs.map.setCenter([Number(a), Number(b)]);
        this.$refs.map.setCenter(item);
      } else {
        item = this.currentItem;
        // let [a, b] = item.location.split(',');
        // this.$refs.map.setCenter([Number(a), Number(b)]);
        this.$refs.map.setCenter(item);
      }
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) != -1;
      };
    },
    initWebSocket() {
      let url = [];
      this.projectList = JSON.parse(localStorage.getItem("ProjectList"));
      this.projectList.forEach((item) => {
        url.push("/topic/app/" + item.projectId + "/" + item.projectId);
      })
      this.oSoc = new COMM.WebSocket_W("emseventv2");
      this.oSoc.creat();
      this.oSoc.connect();
      setTimeout(() => {
        let _this = this;
        this.oSoc.init(url, function (res) {
          console.log(res)
          if (res) {
            _this.isAlarmBlock = true;
            _this.alarmMsg = res;
          }
        })
      }, 2000)
    },
    panelClick(item) {
      this.projectStatus = item.id;
    }
  }
};
</script>

<style lang="scss" scoped>
.s-home {
  width: 100%;
  height: 100%;
  // background: url('/static/images/system/bj.png');
  background: #F3F7FF;
  overflow: hidden;
  position: absolute;

  .s-header {
    position: relative;
    z-index: 99;
  }

  .s-map {
    width: calc(100% - 790px);
    height: calc(100% - 140px);
    z-index: 0;
    top: 115px;
    left: 380px;
  }

  .s-top-block {
    height: 50px;
    position: relative;
    top: -5px;
    z-index: 0;
  }

  .s-left {
    width: 360px;
    display: inline-block;
    position: absolute;
    top: 70px;
    left: 10px;
  }

  .s-right {
    width: 400px;
    display: inline-block;
    position: absolute;
    top: 70px;
    right: 30px;
  }

  .s-list-panel {
    background: #fff;
    border: 0;
    box-shadow: 0px 3px 6px 0px #829AC6;
    height: 36px;
    line-height: 25px;
    position: absolute;
    top: 130px;
    z-index: 10;
    left: 60%;
    padding: 5px;

    ul {
      li {
        float: left;
        margin-left: 15px;
        cursor: pointer;

        img {
          width: auto;
          height: 21px;
          // display: inline-block;
        }

        span {
          color: #606475;
          font-size: 14px;
          font-family: PingFang;
          font-weight: 500;
          // margin-left: -5px;
        }
      }

      li:last-child {
        margin-right: 15px;
      }
    }

    [class*=" el-icon-"],
    [class^=el-icon-] {
      font-size: 30px;
      vertical-align: middle;
    }

    .normalLegend:before {
      color: #5BC69C;
    }

    .debugLegend:before {
      color: #EB6271;
    }

    .buildLegend:before {
      color: #FFDD46;
    }

    .offlineLegend:before {
      color: #C8D5E9;
    }
  }

  .s-hide-panel {
    position: absolute;
    bottom: 20px;
    left: 70%;
    height: 44px;
    line-height: 20px;

    &:hover {
      cursor: pointer;
    }
  }

  .alarmBlock {
    position: fixed;
    bottom: 25px;
    right: 410px;
    z-index: 9999;
  }

  >>> .el-icon-circle-close {
    position: absolute;
    top: 143px;
    left: 32.2%;
    z-index: 99;
  }

  >>> .el-icon-circle-close::before {
    color: #c0c4cc;
  }
}
</style>
<style lang="scss">
.select-down {
  // background-color: rgba(4, 39, 102, .8) !important;
  // border-color: #335eab !important;

  // .el-scrollbar {
  //     li {
  //         color: #76defc;

  //         &:hover {
  //             background-color: rgba(4, 39, 102, .8) !important;
  //             color: #ffffff !important;
  //         }
  //     }
  // }

  .popper__arrow {
    display: none;
  }
}

.s-search {
  border: 0 !important;
  box-shadow: 0px 3px 6px 0px #829AC6;
  padding: 0px !important;
  position: absolute;
  top: 130px;
  left: 21%;
  width: 300px;

  input {
    // background: transparent !important;
    border: 0 !important;
    color: #3d9bd4;
    width: 235px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &::-webkit-input-placeholder {
      color: #3d9bd4;
    }
  }

  .el-input__suffix {
    // left: 235px;
    position: absolute;
    right: 0;
  }

  .el-input__prefix,
  .el-input__suffix {
    background: #4A83F7 !important;
    border-radius: 0 4px 4px 0;
    color: #fff;
  }

  .el-icon-search {
    cursor: pointer;
    font-size: 12px;
    width: 70px;
  }
}

.left-show {
  -webkit-animation-name: panelLeftA;
  animation-name: panelLeftA;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

.left-hide {
  -webkit-animation-name: panelRightA;
  animation-name: panelRightA;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

.right-show {
  -webkit-animation-name: panelLeftB;
  animation-name: panelLeftB;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

.right-hide {
  -webkit-animation-name: panelRightB;
  animation-name: panelRightB;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
}

@keyframes panelLeftA {
  from {
    left: 20px;
  }

  to {
    left: -418px;
    -webkit-transform: translateX(-120px);
    transform: translateX(-120px);
  }
}

@keyframes panelRightA {
  from {
    left: -418px;
  }

  to {
    left: 140px;
    -webkit-transform: translateX(-120px);
    transform: translateX(-120px);
  }
}

@keyframes panelLeftB {
  from {
    right: -95px;
  }

  to {
    right: -533px;
    -webkit-transform: translateX(-120px);
    transform: translateX(-120px);
  }
}

@keyframes panelRightB {
  from {
    right: -513px;
  }

  to {
    right: -95px;
    -webkit-transform: translateX(-120px);
    transform: translateX(-120px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/home/index.vue